import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

export default function Footer({ settings }) {
  const s = settings || {};
  return (
    <footer className="relative mt-32 border-t border-white/10 bg-[#030712] overflow-hidden">
      <div className="absolute inset-0 rr-grid-bg opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center gap-2" data-testid="footer-logo">
            {s.logo_url ? (
              <img src={s.logo_url} alt={s.company_name || "Rise Rift"} className="h-12 w-auto object-contain drop-shadow-[0_0_18px_rgba(47,107,255,0.5)]" />
            ) : (
              <>
                <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#2F6BFF] to-[#4DA8FF] flex items-center justify-center font-bold text-lg">R</span>
                <span className="text-xl font-semibold">{s.company_name || "Rise Rift"}</span>
              </>
            )}
          </Link>
          <p className="mt-5 text-slate-400 max-w-md leading-relaxed">
            {s.tagline || "Create Digital Shifts"}. We build brands, create cinematic content, and leverage AI to drive measurable business growth.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={s.instagram || "https://instagram.com/riseriftmedia_"}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="w-10 h-10 rounded-full border border-white/10 hover:border-[#4DA8FF]/60 hover:bg-[#4DA8FF]/10 flex items-center justify-center transition"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#4DA8FF] font-semibold">Explore</h4>
          <ul className="mt-5 space-y-3 text-slate-300">
            <li><Link className="hover:text-white" to="/services">Services</Link></li>
            <li><Link className="hover:text-white" to="/work">Our Work</Link></li>
            <li><Link className="hover:text-white" to="/podcast">Podcast Studio</Link></li>
            <li><Link className="hover:text-white" to="/ai-solutions">AI Solutions</Link></li>
            <li><Link className="hover:text-white" to="/blogs">Blogs</Link></li>
            <li><Link className="hover:text-white" to="/about">About</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#4DA8FF] font-semibold">Contact</h4>
          <ul className="mt-5 space-y-4 text-slate-300 text-sm">
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#4DA8FF]" />
              <div>
                <a href={`tel:${(s.phone_primary || "").replace(/\s/g, "")}`} className="block hover:text-white" data-testid="footer-phone-1">{s.phone_primary || "+91 7887618891"}</a>
                <a href={`tel:${(s.phone_secondary || "").replace(/\s/g, "")}`} className="block hover:text-white" data-testid="footer-phone-2">{s.phone_secondary || "+91 9325390249"}</a>
              </div>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#4DA8FF]" />
              <a href={`mailto:${s.email || "info@riseriftmedia.com"}`} className="hover:text-white" data-testid="footer-email">{s.email || "info@riseriftmedia.com"}</a>
            </li>
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#4DA8FF]" />
              <span className="leading-relaxed">{s.address || "Pune, Maharashtra, India"}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Rise Rift. All rights reserved.</span>
          <span>Crafted with cinematic intent · Pune, India</span>
        </div>
      </div>
    </footer>
  );
}
